<script>
import { defineComponent } from 'vue'
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue"
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue"
import InfoCards from "@js/components/InfoCards/Components/InfoCards.vue"
import PartnershipLayout from "@js/Shared/PartnershipLayout.vue"
import { useCallbackStore } from "@js/store/CallbackStore.js"
import FaqComponent from "@js/components/Faq/FaqComponent.vue"

// иконки
import shield_svg from '@img/guarantee/shield.svg'
import star_svg from '@img/guarantee/star.svg'
import clock_svg from '@img/guarantee/clock.svg'
import money_svg from '@img/guarantee/money.svg'
import delivery_svg from '@img/guarantee/delivery.svg'
import certificate_svg from '@img/guarantee/certificate.svg'

export default defineComponent({
    layout: PartnershipLayout,
    name: "B2BForAgroPage",
    components: { InfoCards, Breadcrumbs, MobileTopBar, FaqComponent },
    data() {
        return {
            // Преимущества (две группы для InfoCards)
            items_group_1: [
                {
                    logo: shield_svg,
                    title: 'Металл по ГОСТ/ТУ с подтверждением',
                    description: 'Профильные и круглые трубы, уголок, швеллер, лист/профнастил. Марка стали и прокатка подтверждаются документально.',
                },
                {
                    logo: certificate_svg,
                    title: 'Паспорта качества и прослеживаемость',
                    description: 'Передаём МК/сертификаты завода, фиксируем партии/плавки в закрывающих документах и спецификациях.',
                },
                {
                    logo: delivery_svg,
                    title: 'Доставка по Москве/МО и всей РФ',
                    description: 'Отгрузка со склада, согласованные тайм-слоты, при необходимости — подбор транспорта и помощь с разгрузкой.',
                },
            ],
            items_group_2: [
                {
                    logo: money_svg,
                    title: 'НДС, ЭДО и возможная отсрочка',
                    description: 'Полный пакет документов, электронный документооборот. Отсрочка — по договору и кредитной оценке.',
                },
                {
                    logo: star_svg,
                    title: 'Спецусловия на сезонные закупки',
                    description: 'Квоты под посевную/уборочную, резерв и фиксация цены на согласованный срок.',
                },
                {
                    logo: clock_svg,
                    title: 'Персональный менеджер и SLA',
                    description: 'Единое окно, планирование поставок, контроль сроков и статусов на каждом этапе.',
                },
            ],

            // SEO-FAQ (ровно 5)
            faqItems: [
                {
                    question: 'Что поставляете для агросектора?',
                    answer: `<p>Поставляем металлопрокат для строительства/ремонта ангаров, зерноскладов, навесов, теплиц и техники: <strong>трубы профильные и круглые</strong>, <strong>уголок</strong>, <strong>швеллер</strong>, <strong>лист горячекатаный/оцинкованный</strong>, <strong>профнастил</strong>, полоса/квадрат по запросу. Подбираем сечения и толщины по ТЗ и нагрузкам.</p>`
                },
                {
                    question: 'Какой минимальный объём и можно ли смешивать позиции?',
                    answer: `<p>Минимальная отгрузка — от <strong>3 тонн</strong>. Смешанные партии (труба + лист + уголок/швеллер) комплектуем под проект; укажем партии/плавки в спецификации.</p>`
                },
                {
                    question: 'Делаете резку, упаковку и маркировку мест?',
                    answer: `<p>Да. Выполняем <strong>резку в размер</strong> и <strong>раскрой листа</strong>, укладываем прокладки, стягиваем, маркируем места, прикладываем упаковочные листы — ускоряет приёмку и монтаж.</p>`
                },
                {
                    question: 'Сроки поставки и география доставки?',
                    answer: `<p>При наличии на складе — отгрузка <strong>день-в-день</strong> по Москве/МО. В регионы РФ — согласуем маршрут, сроки и тайм-слоты с учётом вашего графика работ.</p>`
                },
                {
                    question: 'Есть НДС/ЭДО и можно ли зафиксировать цену?',
                    answer: `<p>Работаем с <strong>НДС</strong>, поддерживаем <strong>ЭДО</strong>. По заявке фиксируем цену на согласованный срок; <strong>отсрочка</strong> возможна по договору и результатам оценки.</p>`
                },
            ],
        }
    },
    methods: {
        openForm() {
            this.callbackStore.showBaseCallbackPopup({
                title: 'Запросить КП для сельхозпредприятия',
                bitrix_title: 'Заявка на партнёрство (агросектор • металлопрокат)',
            })
        }
    },
    setup() {
        const callbackStore = useCallbackStore()
        return { callbackStore }
    }
})
</script>

<template>
    <div>
        <div class="bg-black pt-5 md:pt-10 pb-[150px] text-white">
            <div class="container">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-10">
                    <div class="flex items-center justify-center">
                        <div>
                            <Breadcrumbs class="text-white" color="#ffcf33"/>
                            <h1 class="text-2xl md:text-4xl font-bold mb-5 mt-5">
                                B2B-решения для сельхозпроизводителей
                            </h1>
                            <p class="md:text-xl mb-5 md:max-w-[80%]">
                                Металлопрокат для ангаров, зерноскладов, тепличных комплексов и ремонта сельхозтехники. Поставки со склада в Москве/МО и доставка по РФ.
                            </p>
                            <button
                                @click.prevent="openForm"
                                class="flex max-md:w-full justify-center items-center text-black md:hover:text-baseYellow border-2 border-baseYellow bg-baseYellow md:hover:bg-transparent font-bold rounded-lg text-sm px-14 py-2.5 focus:outline-none transition cursor-pointer uppercase"
                            >
                                Запросить КП
                            </button>
                        </div>
                    </div>
                    <div class="flex items-center justify-center max-md:hidden">
                        <img
                            src="@img/b2b/agro/top-bg.webp"
                            class="max-h-[500px] rounded-full aspect-square object-cover"
                            alt="Металлопрокат для агросектора"
                            title="Поставки металлопроката для сельхозпроизводителей"
                        />
                    </div>
                </div>
            </div>
        </div>

        <!-- Что делаем (с SEO-текстом вместо картинки) -->
        <section class="bg-white rounded-t-[25px] md:rounded-t-[50px] -mt-[100px] md:mb-20">
            <div class="container pt-10 md:pt-20">
                <div class="grid grid-cols-1 gap-5">
                    <!-- SEO-текстовый блок -->
                    <div class="bg-grayBg p-5 md:p-7 rounded-lg md:rounded-2xl">
                        <h3 class="text-xl md:text-2xl font-bold mb-3">
                            Металлопрокат для агропредприятий — Москва и регионы РФ
                        </h3>
                        <p class="mb-3">
                            Снабжаем агросектор «под ключ»: <strong>трубы профильные и круглые</strong>, <strong>уголок</strong>, <strong>швеллер</strong>,
                            <strong>лист/профнастил</strong>. Под вашу программу работ обеспечим комплектовку, <strong>резку в размер</strong>, упаковку/маркировку и
                            <strong>доставку</strong> — по Москве/МО и в регионы России.
                        </p>
                        <p class="mb-3">
                            Поставки по <strong>ГОСТ/ТУ</strong> с паспортами качества и прослеживаемостью. Для сезонных закупок доступны <strong>спецусловия</strong>;
                            работаем с <strong>НДС</strong>, поддерживаем <strong>ЭДО</strong>, возможна <strong>отсрочка</strong> по договору. Минимальная партия — от <strong>3 тонн</strong>.
                        </p>
                        <ul class="list-disc list-outside space-y-2 ps-5 font-medium">
                            <li>маркировка мест и упаковочные листы — быстрая приёмка и монтаж;</li>
                            <li>планирование поставок под посевную/уборочную без простоев;</li>
                            <li>резерв и фиксация цены на согласованный срок.</li>
                        </ul>
                    </div>

                    <!-- Плитки услуг -->
                    <div>
                        <div class="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-5 h-full">
                            <div class="flex items-center justify-center bg-grayBg p-4 md:p-5 rounded-lg md:rounded-2xl font-medium text-center text-sm md:text-base lg:text-lg">
                                <p>Поставки труб, уголков, швеллеров, листа/профнастила</p>
                            </div>
                            <div class="flex items-center justify-center bg-grayBg p-4 md:p-5 rounded-lg md:rounded-2xl font-medium text-center text-sm md:text-base lg:text-lg">
                                <p>Комплектовка под ангары, зерносклады, теплицы</p>
                            </div>
                            <div class="flex items-center justify-center bg-grayBg p-4 md:p-5 rounded-lg md:rounded-2xl font-medium text-center text-sm md:text-base lg:text-lg">
                                <p>Резка в размер и раскрой листа</p>
                            </div>
                            <div class="flex items-center justify-center bg-grayBg p-4 md:p-5 rounded-lg md:rounded-2xl font-medium text-center text-sm md:text-base lg:text-lg">
                                <p>Доставка по Москве/МО и всей РФ</p>
                            </div>
                            <div class="flex items-center justify-center bg-grayBg p-4 md:p-5 rounded-lg md:rounded-2xl font-medium text-center text-sm md:text-base lg:text-lg">
                                <p>Документы с НДС, ЭДО и возможная отсрочка</p>
                            </div>
                            <div class="flex items-center justify-center bg-grayBg p-4 md:p-5 rounded-lg md:rounded-2xl font-medium text-center text-sm md:text-base lg:text-lg">
                                <p>Упаковка, прокладки и маркировка мест</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Карточки преимуществ -->
        <InfoCards :items_group_1="items_group_1" :items_group_2="items_group_2" class="mb-5 md:mb-20" />

        <!-- Два инфоблока -->
        <div class="container">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-5 mb-5 md:mb-20">
                <div class="bg-grayBg p-5 md:p-10 rounded-lg md:rounded-2xl">
                    <h2 class="text-2xl md:text-3xl font-bold mb-5">
                        Снимаем рутину снабжения у агрокомпаний
                    </h2>
                    <p class="mb-3">
                        Берём на себя подбор по ГОСТ/ТУ, комплектовку под ангар/склад/теплицу и ремонт техники, упаковку, маркировку и логистику.
                    </p>
                    <p class="mb-3">
                        Планируем поставки с учётом сезонных пиков: посевной и уборочной — без простоев и срывов сроков.
                    </p>
                    <p class="mb-3">Закрываем задачи:</p>
                    <ul class="list-disc list-outside space-y-3 ps-5 font-medium">
                        <li>подбор сечений и толщин под расчётные нагрузки;</li>
                        <li>комплектовка, резка в размер и маркировка мест;</li>
                        <li>доставка в хозяйство, согласование тайм-слотов;</li>
                        <li>документы с НДС, ЭДО, при необходимости — отсрочка.</li>
                    </ul>
                </div>

                <div class="bg-grayBg p-5 md:p-10 rounded-lg md:rounded-2xl">
                    <h2 class="text-2xl md:text-3xl font-bold mb-5">
                        Как начать сотрудничество
                    </h2>
                    <p class="mb-3">
                        Оставьте заявку — подготовим КП под объёмы, сроки и сезонность. Закрепим менеджера и согласуем SLA по поставкам.
                    </p>
                    <ul class="list-disc list-outside space-y-3 ps-5 font-medium">
                        <li>спецусловия и квоты на сезонные закупки;</li>
                        <li>личный кабинет: онлайн-заказы и статусы отгрузок;</li>
                        <li>полный пакет документов: НДС и ЭДО.</li>
                    </ul>
                    <button
                        @click.prevent="openForm"
                        class="mt-4 flex justify-center items-center text-white md:hover:text-baseColor border-2 border-baseColor bg-baseColor md:hover:bg-transparent font-bold rounded-lg text-sm px-6 py-2.5 focus:outline-none transition cursor-pointer uppercase"
                    >
                        Оставить заявку
                    </button>
                </div>
            </div>
        </div>

        <section class="container">
            <FaqComponent
                title="FAQ для сельхозпредприятий"
                subtitle="Условия сотрудничества: ассортимент, объёмы, доставка, резка/упаковка, НДС/ЭДО и цены."
                :items="faqItems"
                schema-id="schema-agro-faq-jsonld"
            />
        </section>
    </div>
</template>

<style scoped lang="scss">
</style>
